import { useCallback, useEffect, useMemo, useState } from 'react';
import { getAssetCommentPending } from '../../../api';
import { AssetCommentPending } from '../../../types';

export function buildPendingCommentCountMap(list: AssetCommentPending[]): Map<string, number> {
  const map = new Map<string, number>();
  for (const item of list) {
    map.set(`${item.category}|${item.name}`, item.count);
  }
  return map;
}

export function useProjectAssetComments(projectId: string | undefined, enabled: boolean) {
  const [pending, setPending] = useState<AssetCommentPending[]>([]);

  const reloadAssetComments = useCallback(async () => {
    if (!projectId || !enabled) return;
    try {
      const rows = await getAssetCommentPending(projectId);
      setPending(rows || []);
      // 通知各资产评论按钮重新拉取「最新评论」预览（即使未处理数量没变，最新评论也可能已变）。
      window.dispatchEvent(new Event('asset-comments-updated'));
    } catch {
      // Non-critical: badge counts; keep current state on failure.
    }
  }, [projectId, enabled]);

  useEffect(() => {
    reloadAssetComments();
  }, [reloadAssetComments]);

  const pendingCommentCountMap = useMemo(() => buildPendingCommentCountMap(pending), [pending]);

  return { pendingCommentCountMap, reloadAssetComments };
}
